import script from "./supervisopn-reporting.vue?vue&type=script&lang=ts&setup=true"
export * from "./supervisopn-reporting.vue?vue&type=script&lang=ts&setup=true"

import "./supervisopn-reporting.vue?vue&type=style&index=0&id=5d585a02&scoped=true&lang=scss"
import "./supervisopn-reporting.vue?vue&type=style&index=1&id=5d585a02&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d585a02"]])

export default __exports__